<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-epigraph element-without-heading" id="epigraph">
<div class="text" id="epigraph-text">
<div class="blockquote-container prose with-attribution">
<blockquote class="prose with-attribution">
<p class="first blockquote-content blockquote-content-prose blockquote-position-first">“I’ll come to thee by moonlight,</p>
<div class="paragraph-and-attribution">
<p class="subsq blockquote-content blockquote-content-prose">though hell should bar the way.”</p>
<p class="blockquote-attribution blockquote-position-last"><i>The Highwayman </i>Alfred Noyes (1880-1958)</p>
</div>
</blockquote>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?0e784cd0